<template>
  <div v-if="showDiagnose" class="diagnose-container">
    <div class="diagnose-wrap">
      <div class="diagnose">
        <img class="diagnose-bg" src="@/assets/diagnose-bg.png" alt="">
        <div class="diagnose-title">诊断评估</div>
        <div class="diagnose-content">
          <div class="diagnose-content-wrap" v-for="(item, index) in contents" :key="index">
            <span class="content-title">{{ item.title }}</span>
            <span class="content-body">{{ item.detail }}</span>
          </div>
        </div>
        <div class="diagnose-footer">
          <div class="diagnose-footer-checkbox">
            <el-tooltip effect="dark" popper-class="diagnose-tooltip" :offset="10"
              v-model="showTooltip" content="请勾选确认提示后再开始诊断" placement="top-start">
              <el-checkbox v-model="checked" :class="{'is-checked': checked}"></el-checkbox>
            </el-tooltip>
          </div>
          <div class="diagnose-footer-title" @click="changeCheckbox">
            <span class="title-left">本人已知晓：</span>
            <span class="title-right">
              诊断半年内只能参与一次，中间不能暂停，考试时间较长已确认进入诊断答题。
            </span>
          </div>
        </div>
        <div class="diagnose-btns">
          <button class="btn-reject" @click="closeDiagnose">暂不参加</button>
          <button class="btn-start" @click="startDiagnose">
            {{isStartBtnClick ? `（${timeConut}s）` : "开始诊断"}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DiagnoseModel",
  props: {
    showDiagnose: {
      type: Boolean,
      required: true,
    },
    diagnoseDetail: {
      type: Object,
      required: true,
      default: () => ({})
    },
  },
  watch: {
    diagnoseDetail: {
      handler(val) {
        // console.log(val, 'diagnoseDetail');
        const {time, title, totalScore, practiceInfo} = val;
        this.contents[0].detail = title;
        this.contents[1].detail = `${time} 小时`;
        this.contents[2].detail = `${totalScore} 分`;
        this.contents[3].detail = `${this.getQuenstionDetail(practiceInfo)}`;
      },
      deep: true
    }
  },
  data() {
    return {
      timeConut: 10,
      timeConutTimer: null,
      checked: false,
      showTooltip: !false,
      isStartBtnClick: false,
      quenstionTypeMap: {
        1: '编程题(普通)',
        2: '编程题(OI)',
        3: '选择填空'
      },
      contents: [
        {
          detail: "",
          title: "诊断名称："
        },
        {
          detail: "",
          title: "答题时间："
        },
        {
          detail: "",
          title: "题目总分："
        },
        {
          detail: "",
          title: "题目内容：",
        },
      ]
    }
  },
  mounted() {
    this.appendToBody();
  },
  unmounted() {
    this.clearTimer();
  },
  destroyed() {
    this.clearTimer();
  },
  methods: {
    appendToBody() {
      const body = document.querySelector("body");
      if (body.append) {
          body.append(this.$el);
      } else {
          body.appendChild(this.$el);
      }
    },
    changeCheckbox() {
      this.checked = !this.checked;
      if(this.checked) this.showTooltip = false;
    },
    closeDiagnose() {
      // console.log("关闭弹窗");
      this.clearTimer();
      this.$emit("closeDiagnose");
    },
    startDiagnose() {
      if (!this.checked) {
        this.showTooltip = true;
        let timer = setTimeout(() => {
          const tooltipDom = document.getElementsByClassName("diagnose-tooltip")[0];
          if(tooltipDom) {
            tooltipDom.style.zIndex = "9999";
            tooltipDom.style.opacity = "0.8";
          }
          setTimeout(timer);
        }, 100);
        return;
      }
      // console.log("开始评测");
      if (this.isStartBtnClick) return;
      this.isStartBtnClick = true;
      this.timeConutTimer = setInterval(() => {
        this.timeConut--;
        if(this.timeConut === 0) {
          this.clearTimer();
          this.$emit("startDiagnose");
          this.closeDiagnose();
        }
      }, 1000);
    },
    clearTimer() {
      this.timeConut = 10;
      this.isStartBtnClick = false;
      clearInterval(this.timeConutTimer);
      this.timeConutTimer = null;
    },
    getQuenstionDetail(quenstions) {
      if (quenstions && quenstions.length) {
        let res = {}, strArr = [];
        quenstions.map(item => {
          const { type, count } = item
          if(res[type] === undefined) {
            res[type] = +count
          } else {
            res[type] += +count
          }
        });
        for(let item in res) {
          if(Number(res[item])) strArr.push(`${this.quenstionTypeMap[item]} ${res[item]} 道`)
        }
        return strArr.join('、');
      }
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #FA9E00;
    border-color: #FA9E00;
}
.diagnose-container {
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  z-index: 9999;
  position: fixed;
  align-items: center;
  justify-content: center;
  font-family: 'PingFang SC';
  background: rgba(0, 0, 0, 0.6);
  .diagnose-wrap {
    width: 512px;
    height: 445px;
    .diagnose {
      width: 512px;
      height: 445px;
      overflow: hidden;
      position: relative;
      border-radius: 12px;
      transform: translateY(-38px);
      &-bg {
        top: 0;
        position: absolute;
      }
      &-title {
        width: 100%;
        height: 106px;
        font-size: 30px;
        font-weight: 600;
        color: #5C2705;
        position: absolute;
        text-align: center;
        line-height: 106px;
      }
      &-content {
        top: 106px;
        left: 40px;
        width: 432px;
        height: 206px;
        padding: 24px;
        position: absolute;
        border-radius: 8px;
        background: #FFFFFF;
        &-wrap {
          display: flex;
          font-size: 16px;
          margin-bottom: 16px;
          .content-title {
            min-width: 84px;
            font-weight: 300;
            color: #666666;
          }
          .content-body {
            font-weight: 500;
            padding-right: 20px;
          }
        }
      }
      &-footer {
        left: 40px;
        width: 432px;
        bottom: 60px;
        height: 60px;
        display: flex;
        font-size: 12px;
        line-height: 17px;
        color: #6D401B;
        position: absolute;
        justify-content: space-around;
        &-checkbox {
          margin-right: 6px;
          /deep/ .el-checkbox__inner::after {
            left: 4.5px;
          }
          /deep/ .el-checkbox__inner, .el-checkbox__inner:hover, .el-checkbox__input.is-focus .el-checkbox__inner {
            border: 0.5px solid#6D401B;
          }
        }
        .is-checked {
          /deep/ .el-checkbox__inner, .el-checkbox__inner:hover, .el-checkbox__input.is-focus .el-checkbox__inner {
            border-color: transparent;
          }
        }
        &-title {
          padding-top: 0.5px;
          span {
            line-height: 18px;
          }
          .title-left {
            font-weight: 500;
          }
          .title-right {
            font-weight: 400;
          }
        }
      }
      &-btns {
        bottom: 0;
        width: 512px;
        height: 64px;
        display: flex;
        position: absolute;
        align-items: center;
        flex-direction: row;
        justify-content: center;
        background: #FFFFFF;
        button {
          width: 180px;
          height: 40px;
          border: none;
          outline: none;
          margin: 0 16px;
          font-size: 16px;
          cursor: pointer;
          font-weight: 500;
          border-radius: 20px;
        }
        .btn-reject {
          color: #666666;
          background: #F5F6F7;
        }
        .btn-start {
          color: #FFFFFF;
          background: #FA9E00;
        }
      }
    }
  }
}
</style>
